import React, { useContext } from "react";
import Header from "./header";
import Footer from "./footer";
import Counter from "./countertext";
import HowToApply from "./howtoapply";
import { useState, useEffect } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import HomeCounters from "./Homecounters";
import CircularScrollProgress from "./Circularprogress";
import CitySelector from "./User/CitySelectore";

import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";

function Section8companyregistration() {

   
   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email: parsedUser.email || "",
          user_contact_number: parsedUser.mobile || "",
          user_city: parsedUser.city || "",
        }));
      }
    }, []);

   const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };


   const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact_number: '', user_city: '' })
  
        const [errors, setErrors] = useState({});

           const { services, loading, error } = useContext(ServicesContext);  
           if (loading) {
              return <div>Loading...</div>;  // Show loading state while fetching data
          }
        
          if (error) {
               return <div>{error}</div> // Show error state if there was an issue fetching data
          }
           const service = services.find(s => s.service_id === 4);
     
        const validateForm = () => {
           const newErrors = {};
     
           if (!newData.user_name.trim()) {
              newErrors.user_name = 'Name is required.';
           }else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
            newErrors.user_name = '*Name should only contain letters and spaces.';
          }
    
     
           if (!newData.user_email.trim()) {
              newErrors.user_email = 'Email is required.';
           } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
              newErrors.user_email = 'Enter a valid email address.';
           }
     
         //   if (newData.user_contact_number && !/^\d{10}$/.test(newData.user_contact_number)) {
         //      newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
         //   }
           if (!newData.user_contact_number.trim()) {
            newErrors.user_contact_number = '*number is required.';
          } else if (!/^\d{10}$/.test(newData.user_contact_number)) {
            newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
          }
     
           if (!newData.user_city) {
              newErrors.user_city = 'City/District is required.';
           }
     
           setErrors(newErrors);
           return Object.keys(newErrors).length === 0; // No errors
        };
     
     


            const formPutPartenshipdeed = async (e) => {
                 e.preventDefault();

                     // ✅ Check if user is logged in
       // if (!token) {
      //     alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //    navigate('/login'); // 👈 Use this if you're using React Router
      //    return;
      // }
                 if (!validateForm()) return;
               
                   localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
                  
               };
  


   return (
      <div>

         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <p className="pdrl-text"><img src="assets/img/image/Line.png" className="line-image" /> <span className="text-color">250k+</span> <span>People trust us</span></p>
                        <h1 className="sk-text-color">Section 8 Company Registration</h1>
                        <p className="pdrl-text">Get Section 8 Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Govt. Fees As per actual Extra)</span></p>
                        <p className="pd-text">Government fees and stamp duties are extra. Please fill out the form to receive a detailed quote in seconds. </p>
                        <p className="pd-text text-center star-text">Withwithin 2 Weeks <span><img className="star" src="assets/image/star.svg" alt="" /></span> Transparent Pricing <span><img className="star" src="assets/image/star.svg" alt="" /></span> No Hidden Fees.</p>
                        <div className="couter-all">
                           <div className="row package-section">
                              <p className="ps-text">Get Absolutely Free In Package</p>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/pan-tax-registration.svg" />
                                    <p>Pan & TAN Registration</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/din-and-dsc-for-directors.svg" />
                                    <p>DIN and DSC for Directors</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/complete-document.svg" />
                                    <p>Complete Documentation</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/personal-assistance.svg" />
                                    <p>Personal Assistance</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box dis">
                                    <img src="assets/img/image/pf-and-esc-registration.svg" />
                                    <p>PF and ESIC Registration</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>Section 8 Company  Registration 
</h3><p className="pdrl-text">at Rs.{service?.price}/- Only <br/> <span>(Govt. Fees As per actual Extra)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Name<span className="red">*</span></label>  {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Email Address<span className="red">*</span></label>   {errors.user_email && <p className="error-text">{errors.user_email}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Contact Number<span className="red">*</span></label> {errors.user_contact_number && <p className="error-text">{errors.user_contact_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact_number} onChange={(e) => setNewData({ ...newData, user_contact_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                    <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3 btn-color" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>

         

               <div className="row">
                  <div className="col-lg-12">
                     <div className="space40 bg-white"></div>
                     

                  </div>
                  <div className="col-lg-4">
                     <img src="assets/img/service/service7-main-image.png" alt="" />
                  </div>
                  <div className="col-lg-8">
                  
                     <p className="pd-text">A Section 8 Company is a legally recognized non-profit organization dedicated to advancing causes like education, sports, research, social welfare, arts, science, and environmental conservation. It operates under the framework of the Companies Act, 2013, Section 8.</p>
                     <p className="pd-text">Section 8 Companies are restricted to using their profits solely for the purposes for which they were established. To register this type of company, a minimum of two directors is required, but there is no minimum paid-up capital requirement in India.</p>
                     <p className="pd-text">Register your non-profit entity today with Dm2Legal’s Section 8 Company Registration! Our user-friendly platform enables a quick registration process so you can benefit from numerous tax advantages. Choose our reliable service for a seamless, worry-free registration experience and become a legally registered non-profit entity!</p>
                  </div>

               </div>
               <div className="space20"></div>

            </div>
         </div>

         <div className="space40 bg-white"></div>
         <div className="service-binifits9 sp0 last-section" id="service2" >
            <div className="space50"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Comparison </h2>
                        <div className="space40"></div>
                        <h6 className="hedaing-text">All Service Comparison</h6>
                        <h3 className="hedaing-text-1">Proprietorship vs Limited Liability Partnership (LLP) vs Company</h3>
                        <div className="pro-llp-com-table">
                           <table>
                              <thead>
                                 <tr className="table-heading">
                                    <th>Features</th>
                                    <th>Proprietorship</th>
                                    <th>Partnership</th>
                                    <th>LLP</th>
                                    <th>Company</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr>
                                    <td>Ownership</td>
                                    <td>In a proprietorship, a single individual owns and manages the entire business, making all decisions and retaining full control and responsibility for its operations.</td>
                                    <td>A partnership involves two or more individuals (partners) who share the ownership, management, and responsibilities of the business. Each partner contributes to the business, and profits and losses are typically shared based on the terms outlined in the partnership agreement.</td>
                                    <td>In a partnership, partners generally have unlimited liability, meaning their personal assets can be used to settle business debts or liabilities. This differs from structures like a limited liability company (LLC), where personal assets are protected.</td>
                                    <td>A company is a legal entity distinct from its owners (shareholders). Shareholders enjoy limited liability, meaning their personal assets are generally protected from the company's debts and liabilities.</td>
                                 </tr>
                                 <tr>
                                    <td>Definition</td>
                                    <td>A sole proprietorship is a business owned and operated by a single individual, who has full control over its operations and decisions.</td>
                                    <td>A partnership is a legal arrangement in which two or more individuals or entities come together to share ownership, responsibilities, profits, and liabilities of a business.</td>
                                    <td>An LLP (Limited Liability Partnership) is a hybrid business structure that combines aspects of both partnerships and companies. It provides limited liability to its partners, meaning their personal assets are protected from the business’s liabilities.</td>
                                    <td>A company is a legal entity distinct from its owners (shareholders). It can be structured as a private limited company or a public limited company. Shareholders are the owners of the company, and their liability is limited to their investment in the company.</td>
                                 </tr>
                                 <tr>
                                    <td>Registration Time</td>
                                    <td></td>
                                    <td></td>
                                    <td>7-15 working days</td>
                                    <td></td>
                                 </tr>
                                 <tr>
                                    <td>Promoter Liability</td>
                                    <td></td>
                                    <td>Unlimited Liability</td>
                                    <td></td>
                                    <td>Limited Liability</td>
                                 </tr>
                                 <tr>
                                    <td>Governance</td>
                                    <td>Governed by Local Laws</td>
                                    <td>Under Partnership Act, 1932</td>
                                    <td>LLP Act, 2008</td>
                                    <td>Under Companies Act,2013</td>
                                 </tr>
                                 <tr>
                                    <td>Compliance Requirements</td>
                                    <td>Compliance with Income Tax Laws and other local laws is essential for any business entity to operate legally and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws and other local laws is essential for any business entity to operate legally and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws, Local Laws, the Companies Act, and other applicable regulations is critical for businesses to operate within the legal framework and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws, Local Laws, the Companies Act, and other applicable regulations is critical for businesses to operate within the legal framework and avoid penalties.</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>

         <div className="service-binifits9 sp0 bg-white" >
            <div className="container">
               <HowToApply />
            </div>
         </div>
         <div className="space20 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate text-center">Benefits </h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-4 aos-init" >
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon1.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Legal recognition</a></h4>
                           <p className="font-f-7">Section 8 Companies are recognized and governed under the Companies Act, 2013, which provides them with a legal framework and legitimacy as independent legal entities. This recognition allows them to operate similarly to other registered companies.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon box-icon">
                              <img src="assets/img/icons/service6-icon2.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Limited liability</a></h4>
                           <p className="font-f-7">The liability of members or shareholders in a Section 8 Company is limited, meaning their personal assets are not at risk in the event of debts or liabilities. This feature provides financial security to promoters and encourages them to contribute to social welfare activities confidently.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init" >
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Tax exemptions</a></h4>
                           <p className="font-f-7">Section 8 Companies receive several tax benefits, including exemptions from income tax on surplus income generated through charitable or social welfare activities. Additionally, donors to these organizations are eligible for tax deductions under Section 80G of the Income Tax Act, encouraging further contributions to support their initiatives.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init" >
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon5.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Eligibility for foreign donations</a></h4>
                           <p className="font-f-7">Section 8 Companies are permitted to receive foreign contributions and donations under the Foreign Contribution (Regulation) Act (FCRA), allowing them to secure international funding to support their charitable initiatives.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init" >
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon6.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Perpetual existence</a></h4>
                           <p className="font-f-7">Section 8 Companies enjoy perpetual existence, allowing them to continue operations and fulfill their objectives even if founding members resign or pass away. This feature ensures the continuity of their social welfare activities and long-term impact.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init" >
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/work6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Credibility and trust</a></h4>
                           <p className="font-f-7">Registering as a Section 8 Company enhances the organization's credibility and trustworthiness. It reassures stakeholders—including donors, volunteers, and beneficiaries—that the company is committed to social causes and operates with transparency and accountability.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init" >
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/brand6-4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Access to grants and funding</a></h4>
                           <p className="font-f-7">Section 8 Companies are eligible to apply for grants, funding, and schemes provided by government departments, corporate entities, and international organizations. This financial support helps in the implementation and growth of their social initiatives.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init" >
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Greater reach and impact</a></h4>
                           <p className="font-f-7">Section 8 Companies enjoy broader visibility and recognition within society. They can collaborate with government agencies, NGOs, and other stakeholders to tackle social issues and create a positive impact on communities at large.</p>
                        </div>
                     </div>
                  </div>
               </div>
             
            </div>
         </div>


         <Testimonials />

         <div className="service-binifits9 sp0" id="service2">
            <div className="container work8">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 data-aos="fade-up" className="aos-init aos-animate text-center">Online Registration Procedure of Partnership Firm</h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>

                        <ul className="disc-list">
                         
                           <li>
                               <h3>Step 1   <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our team will carefully review the documents you have submitted, ensuring any false or incorrect information is identified to keep you at ease.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z"></path>
                              </svg>
                           </li>
                           <li>
                              <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our top experts are here to handle all document requirements and meet your registration needs.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z"></path>
                              </svg>
                           </li>
                           <li>
                              <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>The designated expert will proceed with your documents to initiate the Section 8 Company Registration process.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z"></path>
                              </svg>
                           </li>
                           <li>
                              <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Once our team completes the DSC, DIN, and other formalities, please patiently wait for the ROC to issue your COI.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z"></path>
                              </svg>
                           </li>
                           <li>
                              <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                              <span>We will share the COI and unique CIN from the ROC, officially confirming the existence of your Section 8 Company Registration.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z"></path>
                              </svg>
                           </li>
                        </ul>

                        <div className="space80"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>


         
         <div className="bg-white">

            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                              <div className="space30"></div>
                              <div id="general">
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1: What is a Section 8 Company?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       A Section 8 Company is a non-profit organization registered under the Companies Act, 2013, aimed at promoting charitable, social, or environmental causes. It cannot distribute profits and must use earnings for its objectives, enjoying tax benefits and relaxed compliance. 🚀                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2: What are the basic criteria to set up a Section 8 Company in India?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       A Section 8 Company requires at least 2 directors (Private Ltd) or 3 (Public Ltd), a unique name, MoA & AoA defining charitable objectives, a registered office, and directors must obtain DIN & DSC. Profits must be reinvested, and MCA approval is mandatory before incorporation. 
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3: Is a Section 8 Company allowed to generate profits?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, a Section 8 Company can earn profits, but it cannot distribute them as dividends. All earnings must be reinvested to fulfill the company’s charitable objectives.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4:Can NRIs or foreign nationals become directors or shareholders in a Section 8 Company?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">Yes, NRIs and foreign nationals can be directors or shareholders in a Section 8 Company, but they must comply with FEMA regulations and obtain necessary approvals, if required.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5: What is the registration timeline for a Section 8 Company?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Registering a Section 8 Company typically takes 15 to 30 days, depending on MCA approval, documentation, and processing time.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6: How can a Section 8 Company change its registered office address?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       A Section 8 Company must pass a Board Resolution, file Form INC-22 with the MCA, and, if moving to another state, get RD approval and update the MoA.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7: Do Section 8 Companies get tax exemptions?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, Section 8 Companies can get tax exemptions under Section 12A & 80G of the Income Tax Act, but they must apply separately for approval.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8: Is it possible to convert a Section 8 Company into a for-profit company?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    ><p className="font-f-3 weight-500">
Yes, a Section 8 Company can be converted into a for-profit company with MCA approval, compliance with legal formalities, and submission of necessary forms.                                        </p>
                                    </div>
                                 </div>





                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate">Why Choose Us?</h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4>  <span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                           <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4> <span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                           <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4> <span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4> <span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                           <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4> <span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                           <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4> <span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                           <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <WhatsAppScrollButton />

         <Footer />

         <CircularScrollProgress />

      </div>

   );
}
export default Section8companyregistration;